import type { SVGProps } from "react";
import * as React from "react";
import { type iconSize, iconSizeVariants } from "@remi/types/icons";

type SvgIconProps = SVGProps<SVGSVGElement> & {
  size?: iconSize;
};
const UserPencil = ({ size = "sm", ...props }: SvgIconProps) => {
  props.width = iconSizeVariants[size];
  props.height = iconSizeVariants[size];
  return (
    <svg {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.02817 8.93164C8.50869 8.93166 9.01101 8.973 9.50669 9.06934L8.8143 10.2676C8.55637 10.2376 8.29276 10.2217 8.02817 10.2217C7.02924 10.2217 6.02805 10.4272 5.29184 10.9033C4.70781 11.2812 4.26011 11.8461 4.11313 12.71H7.97251C7.9728 12.7993 7.97348 12.895 7.97348 12.9971C7.97347 13.3785 8.02045 13.723 8.10044 14H3.51938C3.09896 13.9997 2.76391 13.6531 2.77231 13.2373C2.80602 11.6168 3.53717 10.5013 4.59165 9.81934C5.61075 9.16037 6.88689 8.93166 8.02817 8.93164Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5106 6.87988C11.7871 6.40125 12.399 6.23823 12.8778 6.51465L13.452 6.8457C13.9305 7.12217 14.0942 7.73323 13.8182 8.21191L11.035 13.0303L11.037 13.0332L9.54477 13.9209C9.19476 14.1289 8.75777 13.9025 8.70883 13.5156L8.70493 13.4355L8.72739 11.7002L11.5106 6.87988ZM9.60239 12.8516L10.1532 12.5234L9.60922 12.209L9.60239 12.8516ZM9.94419 11.375L10.7098 11.8164L12.4686 8.77051L11.703 8.32812L9.94419 11.375ZM12.4334 7.28516C12.3804 7.25451 12.3129 7.27228 12.2821 7.3252L12.1473 7.55664L12.9139 7.99805L13.0477 7.76758C13.0782 7.71446 13.0597 7.64695 13.0067 7.61621L12.4334 7.28516Z"
        fill="currentColor"
      />
      <path
        d="M12.7547 11.2637C13.0406 11.8136 13.2118 12.4685 13.2274 13.2373C13.2358 13.6531 12.9011 13.9999 12.4803 14H10.7391L11.3036 13.6523L11.8768 12.71H11.8875C11.8867 12.7051 11.8854 12.7001 11.8846 12.6953L12.7547 11.2637Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.05356 2C9.68718 2.00018 11.0113 3.32441 11.0116 4.95801C11.0116 6.59182 9.68733 7.91682 8.05356 7.91699C6.41971 7.91691 5.09458 6.59188 5.09458 4.95801C5.09483 3.32435 6.41987 2.00008 8.05356 2ZM8.05356 3.29004C7.13249 3.29012 6.38487 4.03698 6.38461 4.95801C6.38461 5.87925 7.13233 6.62687 8.05356 6.62695C8.97471 6.62678 9.72153 5.8792 9.72153 4.95801C9.72127 4.03703 8.97455 3.29021 8.05356 3.29004Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default UserPencil;
